// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compatible__grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));grid-gap:2rem;margin-bottom:2rem}.compatible__grid>div{border:1px solid var(--dark-blue);text-align:center;background-color:#fff}.compatible__grid>div h4{margin:1rem auto;background:linear-gradient(270deg,var(--dark-blue),var(--green));-webkit-background-clip:text;-webkit-text-fill-color:transparent}", ""]);
// Exports
module.exports = exports;
